/* eslint-disable @typescript-eslint/ban-ts-comment */

/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import stringify from './stringify';
var KEY_DENY_LIST = ['__proto__', 'constructor', 'prototype'];

var sanitizeKey = function sanitizeKey(key) {
  return KEY_DENY_LIST.includes(key.toLowerCase()) ? key.toUpperCase() : key;
};
/**
 * Appends the parameters to the given url.
 * The base url can contain existing query parameters.
 * @param {String} url The base url.
 * @param {Object} parameters The parameters to add.
 * @return {String} A new valid url with the parameters appended.
 */


export function appendQueryParameters(url, parameters) {
  var hash = '';
  var newUrl = url;
  var indexOf = url.indexOf('#');

  if (indexOf !== -1) {
    hash = url.substring(indexOf);
    newUrl = url.substring(0, indexOf);
  }

  return newUrl + (newUrl.indexOf('?') === -1 ? '?' : '&') + stringify(parameters) + hash;
}

function isStringOfNumbers(str) {
  return str.split('').every(function (char) {
    return char.charCodeAt(0) >= 48 && char.charCodeAt(0) <= 57;
  });
}
/**
 * @description Parse the query parameters from the search (window.location.search) part of
 * a URL. This will allow parsing a full JSON tree, however the limitation being all ultimate
 * values will be strings as types can not be accurately inferred from parasing a query-string.
 *
 * @param  {string} search The search string, typically from window.location.search
 * @return {Object}        A map of the query parameters
 */


export function parseQueryString(search) {
  var queryString = search;
  var params = {};

  if (!queryString) {
    return params;
  }

  if (queryString.indexOf('?') === 0) {
    queryString = queryString.substring(1);
  }

  var pairs = queryString.split('&');
  var pairsLength = pairs.length;

  var _loop = function _loop(iPair) {
    var multiLevelKeyRegex = /\[?([^\][]+)\]?/g;
    var keyVal = pairs[iPair].split('=');
    var key = decodeURIComponent(keyVal[0]);
    var value = decodeURIComponent(keyVal[1]);

    if (!multiLevelKeyRegex.test(key)) {
      params[sanitizeKey(key)] = value;
    } else {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      var parentRef = params; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

      var keys = key.match(multiLevelKeyRegex).map(function (keyRes) {
        return keyRes.replace(/[[\]]+/g, '');
      });
      keys.forEach(function (subKey, i) {
        var sanitizedSubKey = sanitizeKey(subKey);
        var isLastKey = i === keys.length - 1;
        var isCurrentKeyValueArray = isLastKey ? false : isStringOfNumbers(keys[i + 1]);

        if (!isLastKey) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          parentRef[sanitizedSubKey] = parentRef[sanitizedSubKey] || (isCurrentKeyValueArray ? new Array() : {});
        } else {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          parentRef[sanitizedSubKey] = value;
        }

        if (!isLastKey) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          parentRef = parentRef[sanitizedSubKey];
        }
      });
    }
  };

  for (var iPair = 0; iPair < pairsLength; iPair += 1) {
    _loop(iPair);
  }

  return params;
}
//# sourceMappingURL=location.js.map